import Extent from '@arcgis/core/geometry/Extent';
import { buildGraphic } from '../../../../sketch-editor/graphics-handler';

export const mergeExtents = (extent: Extent|null, geometry) => {
  if (extent && geometry.type) {
    const featureGraphic = buildGraphic(geometry);
    const featureExtent = featureGraphic.geometry.extent;

    const unionExtent = featureExtent || extentFromPoint(geometry);
    return extent.union(unionExtent);
  }

  return null;
};

// because a point will not have anything for geometry.extent
// the other geometry types will
export const extentFromPoint = (geometry) => {
  if (geometry.type === 'Point') {
    return new Extent({
      xmin: geometry?.coordinates[0],
      ymin: geometry?.coordinates[1],
      xmax: geometry?.coordinates[0],
      ymax: geometry?.coordinates[1],
    });
  }

  return null;
};
